export default __webpack_public_path__ + "static/media/img12.128097f2.svg";